import { httpService } from '@/services/HttpService';

class TrialService {
  // postSMSCode(phone: any): Promise<any> {
  //   return httpService.post(`phone_number`, { phone_number: phone });
  // }
  // getPhoneNumber(): Promise<any> {
  //   return httpService.get(`phone_number`, {}, { isErrorSuppressed: true });
  // }
  // confirmCode(confirmationCode: any): Promise<any> {
  //   return httpService.put(`phone_number/confirm`, { confirmation_code: confirmationCode });
  // }
  postPromocode(workspaceId: number, code: any): Promise<any> {
    return httpService.post(`workspaces/${workspaceId}/trial/activate_with_code`, { code: code });
  }
  activateWorkspace(workspaceId: number): Promise<any> {
    return httpService.post(`workspaces/${workspaceId}/trial`, {});
  }
  getAmounts(): Promise<any> {
    return httpService.get('trial_amounts');
  }
}

export const trialService = new TrialService();
